<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'NavigationItem',
    props: {
      item: Object,
      isSubItem: Boolean,
    },
    computed: {
      ...mapState('auth', ['settings']),
    },
    methods: {
      getActiveRouteClass(item) {
        // Check item itself, if it is match return exact match class
        if (this.isActiveRoute(item)) {
          return `custom-list--active exact menu-item-${item.type}`
        }
        // Otherwise iterate over all subitems to check if group point is active trough children
        let isActive = false
        if (item.subnav && item.subnav.length) {
          for (let i = 0; i < item.subnav.length; i++) {
            if (this.isActiveRoute(item.subnav[i])) {
              isActive = true
              break
            }
          }
        }
        return isActive ? `custom-list--active children menu-item-${item.type}` :
          `custom-list--inactive menu-item-${item.type}`
      },
      getItemTarget(item) {
        item.target = item.type === 'mocs' ? 'external' : item.target
        return item.target && item.target === 'external' ? '_blank' : undefined
      },
      isActiveRoute(item) {
        // Store if item is an exact match including id param with current route
        const isExactActiveWithParams = (
          this.$route.name === item.type &&
          this.$route.params &&
          this.$route.params.id &&
          parseInt(this.$route.params.id) === parseInt(item.reference_id)
        )
        // Store if item is an exact match, having no id param and also route does not having an id param
        const isExactActive = (
          this.$route.name === item.type &&
          (!this.$route.params || !this.$route.params.id) &&
          !item.reference_id
        )

        // Store if item is active
        const isActive = (
          this.$route.name === item.type &&
          this.$route.params.id === item.reference_id
        )

        // Store if item is group and active trough topic
        const isTopicActive = (
          item.type === 'group' &&
          this.$route.name === 'topic' &&
          this.$route.path.indexOf(`/groups/${item.reference_id}/topics/`) > 0
        )
        return isExactActiveWithParams || isExactActive || isActive || isTopicActive
      },
      linkToRoute(item) {
        // use catch to prevent NavigationDuplicated error on console
        this.$router.push({ name: item.type, params: { id: item.reference_id } }).catch(_ => {})
      },
    },
  }
</script>
